import { Box, Stack } from "@mui/material";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { CbhIcon, Text, useModalState } from "@src/appV2/redesign/system/ui-components";
import { useInView } from "react-intersection-observer";

import { ReferralBottomSheet } from "./ReferralBottomSheet";

export function ReferralBanner() {
  const isReferralBannerEnabled = useCbhFlag(CbhFeatureFlag.JOBS_PAGE_REFERRAL_BANNER, {
    defaultValue: true,
  });

  const { amount: referralAmount } = useCbhFlag(CbhFeatureFlag.OFFER_OUTCOME_REFERRAL_AMOUNT, {
    defaultValue: { enabled: false, amount: 20 },
  });

  const referralSheetModalState = useModalState();

  const { ref } = useInView({
    triggerOnce: true,
    threshold: 0,
    onChange: (inView) => {
      if (!inView) {
        return;
      }

      logEvent(APP_V2_APP_EVENTS.JOBS_PAGE_REFERRAL_BANNER_VIEWED);
    },
  });

  if (!isReferralBannerEnabled) {
    return null;
  }

  const handleReferClick = () => {
    logEvent(APP_V2_APP_EVENTS.JOBS_PAGE_REFERRAL_BANNER_CTA_CLICKED);
    referralSheetModalState.openModal();
  };

  return (
    <>
      <Stack
        ref={ref}
        direction="row"
        alignItems="center"
        sx={(theme) => ({
          backgroundColor: theme.palette.info.light,
          borderRadius: 4,
          paddingY: 3,
          paddingX: 5,
          gap: 3,
        })}
      >
        <CbhIcon
          type="gift-outlined"
          color={(theme) => theme.palette.primary.main}
          sx={{ width: 24, height: 24, flexShrink: 0 }}
        />

        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <Text
            semibold
            variant="body2"
            sx={(theme) => ({
              color: theme.palette.text.primary,
            })}
          >
            Help a friend, earn ${referralAmount}
          </Text>
          <Text
            variant="caption"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            Refer someone looking for their next healthcare job.
          </Text>
        </Stack>

        <Box sx={{ flexShrink: 0, paddingY: 1 }}>
          <Button
            variant="contained"
            size="small"
            sx={{
              whiteSpace: "nowrap",
              minWidth: "auto",
              borderRadius: "100px",
              paddingY: 0,
              paddingX: 6,
            }}
            onClick={handleReferClick}
          >
            Refer {"\u2192"}
          </Button>
        </Box>
      </Stack>

      {referralSheetModalState.modalIsOpen ? (
        <ReferralBottomSheet modalState={referralSheetModalState} />
      ) : undefined}
    </>
  );
}
